import React from 'react'

import { PointIcon } from 'src/shared/components/icons/point-icon'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { useToast } from 'src/shared/hooks/use-toast'

interface ShowPointsToastOptions {
  points: number
  duration?: number
  message?: React.ReactNode
}

export function usePointsToast() {
  const { toast } = useToast()
  const isMobile = useIsMobile()

  const showPointsToast = ({ points, duration = 3500, message }: ShowPointsToastOptions) => {
    toast({
      description: message || (
        <div className="flex items-center gap-2">
          <span className={`${isMobile ? 'text-base' : 'text-xl'} text-primary`}>You earned {points}</span>
          <PointIcon className="size-4" />
        </div>
      ),
      duration,
    })
  }

  return { showPointsToast }
}
